<template>
  <div id="register-password-view">
    <div id="header" class="flex f-ai">
      <p>{{ $t('password.change') }}</p>
    </div>
    <SetPassword :auth="auth" :token="token" />
  </div>
</template>

<script>
import SetPassword from '@/components/SetPassword.vue';
export default {
  mounted() {},
  computed: {
    auth() {
      return this.$route.query.auth;
    },
    token() {
      return this.$route.query.token;
    }
  },
  components: {
    SetPassword
  }
};
</script>

<style lang="sass" scoped>
#register-password-view
  position: fixed
  overflow: auto
  top: 0
  left: 0
  height: 100%
  width: 100%
  background: $main-background
  #header
    width: 100%
    background: white
    padding: 20px
    font-weight: 700
    font-size: 22px
@media only screen and (max-width: 576px)
  #header
    max-height: 60px
</style>
